import type {NavigateFunction} from 'react-router';

import type {CurrentProject} from 'common/report/queries/app-api/project-metadata-client';
import type {CurrentUser} from 'common/report/queries/app-api/user-metadata-client';
import type {QueryContextManager} from 'common/query-context';
import type {StorageManager} from 'common/contexts/storage-manager/types';

export type State = {
  showSupportWidget: boolean;
  isSupportWidgetMaximized: boolean;
  isInviteUserModalOpen: boolean;
  closeInviteModalCallback: (() => void) | undefined;
};

export enum ExpansionMode {
  AlwaysExpanded = `always-expanded`,
  AlwaysCollapsed = `always-collapsed`,
  Auto = `auto`,
}

export type PersistedState = {
  expansionMode?: ExpansionMode;
};

export type Props = {
  currentProject: CurrentProject | undefined;
  currentUser: CurrentUser | undefined;
  queryContextManager: QueryContextManager;
  localStorageManager: StorageManager;
  navigate: NavigateFunction;
};
